/**
 * @file Renders the list of claims that a public key's ID token must carry.
 */

import React from "react";
import { Typography } from "antd";

import { W0 } from "@components/Constants";

export type Claim = {
  name: string;
  description: string;
};

type Props = {
  claims: Claim[];
};

/**
 * Renders one paragraph per claim, showing its name and description.
 */
const ClaimsList = ({ claims }: Props): JSX.Element => {
  const claimStyle = {
    marginBottom: W0 / 2,
  };

  /**
   * Renders one claim as its name and its description.
   */
  const renderClaim = ({ name, description }: Claim) => (
    <Typography.Paragraph key={name} style={claimStyle}>
      <Typography.Text code>{name}</Typography.Text>

      {" "}

      <Typography.Text type="secondary">{description}</Typography.Text>
    </Typography.Paragraph>
  );

  return (
    <>
      {claims.map(renderClaim)}
    </>
  );
};

export default ClaimsList;
